import { ANALYTICS_GRAPH_TYPES } from './visuals/graphCatalog';

export const ANALYTICS_SCREEN_IDS = {
  EXECUTIVE_OVERVIEW: 'executive_overview',
  RECRUITMENT: 'recruitment',
  PIPELINE_RISK: 'pipeline_risk',
  QUALITY_OF_HIRES: 'quality_of_hires',
  RECRUITER_PERFORMANCE: 'recruiter_performance'
};

const clone = (value) => JSON.parse(JSON.stringify(value));

export const ANALYTICS_SCREEN_DEFAULTS = {
  [ANALYTICS_SCREEN_IDS.EXECUTIVE_OVERVIEW]: {
    screenId: ANALYTICS_SCREEN_IDS.EXECUTIVE_OVERVIEW,
    locked: true,
    defaultVisibleWidgetIds: [
      'executive_kpi_bar',
      'headcount_targets',
      'requires_attention',
      'ai_weekly_brief',
      'funnel_intelligence',
      'focal_points'
    ],
    defaultWidgetPrefs: {
      executive_kpi_bar: { size: 'large' },
      headcount_targets: { size: 'large' },
      requires_attention: { size: 'medium' },
      ai_weekly_brief: { size: 'medium' },
      funnel_intelligence: { size: 'large' },
      focal_points: { size: 'large' }
    }
  },
  [ANALYTICS_SCREEN_IDS.RECRUITMENT]: {
    screenId: ANALYTICS_SCREEN_IDS.RECRUITMENT,
    locked: false,
    defaultVisibleWidgetIds: [
      'stage_conversion_waterfall',
      'source_quality_matrix',
      'time_to_hire_components',
      'applicant_traffic_map',
      'offer_waterfall',
      'headcount_targets_by_tag_group'
    ],
    defaultWidgetPrefs: {
      stage_conversion_waterfall: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.PIPELINE_FLOW },
      source_quality_matrix: { size: 'medium', activeGraph: ANALYTICS_GRAPH_TYPES.CONDITIONAL_TABLE },
      time_to_hire_components: { size: 'medium', activeGraph: ANALYTICS_GRAPH_TYPES.TABLE },
      applicant_traffic_map: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.WORLD_CHOROPLETH },
      offer_waterfall: { size: 'medium', activeGraph: ANALYTICS_GRAPH_TYPES.PIPELINE_FLOW },
      headcount_targets_by_tag_group: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.GOAL_TRACK }
    }
  },
  [ANALYTICS_SCREEN_IDS.PIPELINE_RISK]: {
    screenId: ANALYTICS_SCREEN_IDS.PIPELINE_RISK,
    locked: false,
    defaultVisibleWidgetIds: [
      'open_roles_risk',
      'stage_bottleneck',
      'offer_stalling',
      'vacancy_forecast',
      'candidate_dropoff_risk'
    ],
    defaultWidgetPrefs: {
      open_roles_risk: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.BUBBLE_CHART },
      stage_bottleneck: { size: 'medium', activeGraph: ANALYTICS_GRAPH_TYPES.HEATMAP },
      offer_stalling: { size: 'medium', activeGraph: ANALYTICS_GRAPH_TYPES.STALLING_OFFERS },
      vacancy_forecast: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.GANTT_TIMELINE },
      candidate_dropoff_risk: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.RISK_ACTION_TABLE }
    }
  },
  [ANALYTICS_SCREEN_IDS.QUALITY_OF_HIRES]: {
    screenId: ANALYTICS_SCREEN_IDS.QUALITY_OF_HIRES,
    locked: false,
    defaultVisibleWidgetIds: [
      'onboarding_health',
      'early_quality_index',
      'retention_timeline',
      'source_quality',
      'probation_performance'
    ],
    defaultWidgetPrefs: {
      onboarding_health: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.STACKED_BAR_LINE },
      early_quality_index: { size: 'medium', activeGraph: ANALYTICS_GRAPH_TYPES.RADAR },
      retention_timeline: { size: 'medium', activeGraph: ANALYTICS_GRAPH_TYPES.RETENTION_HEATMAP },
      source_quality: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.BUBBLE_CHART },
      probation_performance: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.STACKED_BAR_LINE }
    }
  },
  [ANALYTICS_SCREEN_IDS.RECRUITER_PERFORMANCE]: {
    screenId: ANALYTICS_SCREEN_IDS.RECRUITER_PERFORMANCE,
    locked: false,
    defaultVisibleWidgetIds: [
      'recruiter_scorecard',
      'recruiter_radar',
      'load_vs_outcome',
      'time_to_fill',
      'pipeline_conversion',
      'recruiter_velocity',
      'offer_performance',
      'retention_by_recruiter'
    ],
    defaultWidgetPrefs: {
      recruiter_scorecard: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.RECRUITER_CARDS },
      recruiter_radar: { size: 'medium', activeGraph: ANALYTICS_GRAPH_TYPES.RADAR },
      load_vs_outcome: { size: 'medium', activeGraph: ANALYTICS_GRAPH_TYPES.SCATTER },
      time_to_fill: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.BOX_PLOT },
      pipeline_conversion: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.HEATMAP },
      recruiter_velocity: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.LINE_OVER_TIME },
      offer_performance: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.SCATTER },
      retention_by_recruiter: { size: 'large', activeGraph: ANALYTICS_GRAPH_TYPES.SCATTER }
    }
  }
};

export const getAnalyticsScreenDefaults = (screenId) => {
  const defaults = ANALYTICS_SCREEN_DEFAULTS[screenId];
  if (!defaults) {
    return {
      screenId,
      locked: false,
      defaultVisibleWidgetIds: [],
      defaultWidgetPrefs: {}
    };
  }

  return {
    ...defaults,
    defaultVisibleWidgetIds: [...defaults.defaultVisibleWidgetIds],
    defaultWidgetPrefs: clone(defaults.defaultWidgetPrefs)
  };
};
